import { AssetDescription } from '@play-co/timestep-core';
import { BlockId } from '../../defs/block';
import { BlockEntity, spawnBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { blockViewAssets } from '../../util/blockTools';
import { IEffect } from './IEffect';

// types
//-----------------------------------------------------------------------------
export type FuguEffectOptions = {
  subject: BlockEntity;
};

// constants
//-----------------------------------------------------------------------------
const spawnId: BlockId = 'miniFugu';

/*
    fugu generates a movable mini fugu block
*/
export class FuguEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _options: FuguEffectOptions;

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, options: FuguEffectOptions) {
    this._scene = scene;
    this._options = options;
  }

  public static assets(): (string | AssetDescription<any>)[] {
    return blockViewAssets(spawnId);
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    await this._spawnMiniFuguBlock();
  }

  // private: actions
  //-------------------------------------------------------------------------
  private async _spawnMiniFuguBlock() {
    // spawn mini fugu block
    spawnBlockEntity(
      this._scene,
      { id: spawnId },
      this._options.subject.c.position.mapPosition,
    );
  }
}
